module.exports = __webpack_public_path__ + "img/u3361.ca8ea7b6.svg";